import { ExtendedCallHistoryService } from "./extendedCallHistoryService";

export const extendedCallHistoryService = new ExtendedCallHistoryService();